var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 612",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 154 57 C 161 72 172 102 172 102 L 236 134 267 105 386 105 385 94 C 385 94 418 91 467 96 516 100 551 159 552 191 553 223 554 266 554 266 L 488 267 C 488 267 471 301 462 317 446 345 418 363 418 363 L 326 410 327 516 275 544 174 499 172 447 361 341 380 256 C 380 256 375 249 365 244 355 239 353 238 322 240 301 242 269 258 222 285 188 303 155 280 143 262 130 244 103 203 92 180 78 150 70 130 66 109 59 77 59 53 92 36 117 23 147 41 154 57 Z M 223 471 L 279 490 278 439 223 471 Z M 428 138 L 429 287 461 217 509 218 C 509 218 511 185 496 164 481 143 459 138 459 138 L 428 138 Z M 126 89 C 121 75 95 84 101 103 108 125 113 138 122 153 131 169 154 159 150 146 L 126 89 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 157 474 L 130 507 155 542 196 527 157 510 157 474 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 215 535 L 217 581 262 590 274 561 215 535 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 304 548 L 335 573 370 547 355 508 367 487 410 484 416 440 377 423 373 404 344 419 345 526 304 548 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 156 453 L 113 435 121 392 163 389 176 369 159 329 198 302 229 331 251 327 268 287 313 293 316 336 326 343 156 438 156 453 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSystem);
export default __webpack_public_path__ + "static/media/gear-system.c3276298f6f09220fa54e204e92aa1b8.svg";
export { ForwardRef as ReactComponent };